module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'note-frames/page-summary-preview' && templateVars.config ?
				templateVars.config :
				{
	"parserUrl": "/getNoteFrameData/",
	"theme": "tooltipster-note-frames",
	"side": "top"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/note-frames/.variant/page-summary-preview/config.yaml
// module id = 196
// module chunks = 0